<template>
  <el-form
    :model="form"
    ref="form"
    :disabled="disabledForm"
  >
    <!-- PART INFO -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('part-info')}}</h3>
      </div>
      <!-- content -->
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('part-number')"
          prop="partID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-part-number
            :model.sync="form.partID"
            @on-change="autoSaveField( 'partID')"
            @on-data-value="(data) => updateViewData('partNumber', data)"
            :disabled="disabledPart || !isAvailableEditPartNumber"
          ></select-part-number>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('part-sn')"
          prop="partSN"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            @change="autoSaveField( 'partSN')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('qty')"
          prop="qty"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
            @change="autoSaveField( 'qty')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('min-qty')"
          prop="minQty"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.minQty"
            @input="form.minQty = valueNumber($event)"
            @change="autoSaveField( 'minQty')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('entry-date')"
          prop="entryDate"
          class="material-style"
        >
          <date-picker
            v-model="form.entryDate"
            @change="autoSaveField( 'entryDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          prop="nonIncident"
          class="material-style"
        >
          <el-checkbox
            v-model="form.nonIncident"
            @change="autoSaveField( 'nonIncident')"
          >
            {{L10n('non-incident')}}
          </el-checkbox>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('alt-part-number')"
          prop="altPartID"
          class="material-style"
        >
          <select-part-number
            :model.sync="form.altPartID"
            @on-change="autoSaveField( 'altPartID')"
            :disabled="disabledForm"
          >
          </select-part-number>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('shelf-life-limit')"
          prop="shelfLifeLimit"
          class="material-style"
          :class="shelfLifeLimitClass"
        >
          <date-picker
            v-model="form.shelfLifeLimit"
            @change="autoSaveField( 'shelfLifeLimit')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('weight-dimensions')"
          prop="weightDimensions"
          class="material-style"
        >
          <el-input
            :value="form.weightDimensions"
            @input="form.weightDimensions = valueTrimLeft($event)"
            @change="autoSaveField( 'weightDimensions')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-2 col-md-4 col-12">
        <el-form-item
          :label="L10n('mfg-date')"
          prop="supplierPaymentDate"
          class="material-style"
        >
          <date-picker
            v-model="form.supplierPaymentDate"
            @change="autoSaveField( 'supplierPaymentDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-1 col-md-2 col-4">
        <el-form-item
          :label="L10n('n-days')"
          class="material-style"
          :class="classDaysField"
        >
          <el-input
            :value="daysField"
            readonly
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-8">
        <el-form-item
          class="material-style"
          :class="classDaysMessage"
        >
          <el-input
            :value="daysMessage"
            readonly
          />
        </el-form-item>
      </div>
    </div>
    <!-- TAG INFO -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('tag-info')}}</h3>
      </div>
      <!-- content -->
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('tag-info-company')"
          prop="tagInfoCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.tagInfoCompanyID"
            @on-change="autoSaveField( 'tagInfoCompanyID')"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('traceability-company')"
          prop="traceabilityCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.traceabilityCompanyID"
            @on-change="autoSaveField( 'traceabilityCompanyID')"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-6">
        <el-form-item
          :label="L10n('tag-date')"
          prop="tagDate"
          class="material-style"
        >
          <date-picker
            v-model="form.tagDate"
            @change="autoSaveField( 'tagDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.conditionID"
            @on-change="autoSaveField( 'conditionID')"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('release')"
          :rules="getValidationRule('required')"
          prop="releaseID"
          class="material-style"
        >
          <select-response
            :model.sync="form.releaseID"
            @on-change="autoSaveField( 'releaseID')"
            :data="dataSourceRelease.records"
            :isLoading="dataSourceRelease.loading"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <!-- REMARKS -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('remarks')}}</h3>
      </div>
      <!-- content -->
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('stock-remark')"
          prop="stockRemark"
          class="material-style"
        >
          <el-input
            v-model="form.stockRemark"
            @change="autoSaveField( 'stockRemark')"
            type="textarea"
            :rows="4"
          />
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('stock-technical-remark')"
          prop="stockTechnicalRemark"
          class="material-style"
        >
          <el-input
            v-model="form.stockTechnicalRemark"
            @change="autoSaveField( 'stockTechnicalRemark')"
            type="textarea"
            :rows="4"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('sales')"
          prop="salesRemarkID"
          class="material-style"
        >
          <select-response
            :model.sync="form.salesRemarkID"
            @on-change="autoSaveField( 'salesRemarkID')"
            :data="dataSourceSalesRemark.records"
            :fields="{id: 'id', title: 'remark'}"
            :isLoading="dataSourceSalesRemark.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('sales-remark')"
          prop="salesRemark"
          class="material-style"
        >
          <el-input
            :value="form.salesRemark"
            @input="form.salesRemark = valueTrimLeft($event)"
            @change="autoSaveField( 'salesRemark')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-2 col-lg-4">
        <el-form-item
          :label="L10n('sell-exch-price-date')"
          prop="sellExchPriceDate"
          class="material-style">
          <date-picker
            type="date"
            v-model="form.sellExchPriceDate"
            @change="autoSaveField('sellExchPriceDate')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('sell-price')"
          prop="sellPrice"
          class="material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.sellPrice"
            @input="form.sellPrice = valueNumber($event)"
            @change="autoSaveField( 'sellPrice', { payloadData: { sellExchPriceDate: new Date() }})"
          />
        </el-form-item>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-12 price-field">
        <el-form-item
          :label="L10n('exch-price')"
          prop="exchPrice"
          class="price-field__field material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.exchPrice"
            @input="form.exchPrice = valueNumber($event)"
            @change="autoSaveField( 'exchPrice', { payloadData: { sellExchPriceDate: new Date() }})"
          />
        </el-form-item>
        <el-form-item
          prop="sellExchCurrencyID"
          class="price-field__value material-style"
        >
          <select-response
            :model.sync="form.sellExchCurrencyID"
            @on-change="autoSaveField( 'sellExchCurrencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>

    <div class="row">
      <!-- LOCATION -->
      <div class="col-xl-6 col-12">
        <!-- title -->
        <div class="row">
          <div class="col-12">
            <h3 class="blue-text">{{L10n('location')}}</h3>
          </div>
        </div>
        <!-- content -->
        <div class="row">
          <div class="col-lg-4 col-12">
            <el-form-item
              :label="L10n('stock-location')"
              prop="stockLocationID"
              class="material-style"
            >
              <select-response
                :model.sync="form.stockLocationID"
                @on-change="autoSaveField( 'stockLocationID')"
                :data="dataSourceLocation.records"
                :isLoading="dataSourceLocation.loading"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-4 col-12">
            <el-form-item
              :label="L10n('warehouse-location')"
              prop="warehouseLocationID"
              class="material-style"
            >
              <select-response
                :model.sync="form.warehouseLocationID"
                @on-change="autoSaveField( 'warehouseLocationID')"
                :data="dataSourceWarehouseLocation.records"
                :isLoading="dataSourceWarehouseLocation.loading"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-4 col-12">
            <el-form-item
              :label="L10n('out-side-location')"
              prop="externalLocationCompanyID"
              class="material-style"
            >
              <select-company
                :model.sync="form.externalLocationCompanyID"
                @on-change="autoSaveField( 'externalLocationCompanyID')"
                :disabled="disabledForm"
                clearable
              >
              </select-company>
            </el-form-item>
          </div>
        </div>
      </div>
      <!-- STATUS -->
      <div class="col-xl-6 col-12">
        <!-- title -->
        <div class="row">
          <div class="col-12">
            <h3 class="blue-text">{{L10n('status')}}</h3>
          </div>
        </div>
        <!-- content -->
        <div class="row">
          <div class="col-lg-4 col-12">
            <el-form-item
              :label="L10n('status')"
              prop="statusID"
              class="material-style"
            >
              <select-response
                :model.sync="form.statusID"
                @on-change="autoSaveField( 'statusID', { payloadData: { statusDate: new Date() }})"
                :data="dataSourceStatus.records"
                :isLoading="dataSourceStatus.loading"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-4 col-12">
            <el-form-item
              :label="L10n('status-ind')"
              prop="statusInd"
              class="material-style"
            >
              <el-input
                :value="form.statusInd"
                @input="form.statusInd = valueTrimLeft($event)"
                @change="autoSaveField( 'statusInd')"
              />
            </el-form-item>
          </div>
          <div class="col-lg-4 col-12">
            <el-form-item
              :label="L10n('status-date')"
              prop="statusDate"
              class="material-style"
            >
              <button type="button" class="btn btn-size-xs field-top-button" @click="statusDateToday">
                {{L10n('set-today')}}
              </button>
              <date-picker
                v-model="form.statusDate"
                @change="autoSaveField( 'statusDate')"
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </div>

    <!-- SUPPLIER -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('supplier')}}</h3>
      </div>
      <!-- content -->
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('supplier-company')"
          prop="supplierCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.supplierCompanyID"
            @on-change="autoSaveField( 'supplierCompanyID')"
            :disabled="disabledForm"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('owner-company')"
          prop="ownerCompanyID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-company
            :model.sync="form.ownerCompanyID"
            @on-change="autoSaveField( 'ownerCompanyID')"
            :disabled="!isAvailableEditOwner"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('baxpo-number')"
          prop="baxpoNumber"
          class="material-style"
        >
          <el-input
            :value="form.baxpoNumber"
            @input="form.baxpoNumber = valueTrimLeft($event)"
            @change="autoSaveField( 'baxpoNumber')"
          />
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('supplier-order-date')"
          prop="supplierOrderDate"
          class="material-style"
        >
          <date-picker
            v-model="form.supplierOrderDate"
            @change="autoSaveField( 'supplierOrderDate')"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12 price-field">
        <el-form-item
          :label="L10n('accounting-value')"
          prop="accountingValue"
          class="price-field__field material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.accountingValue"
            @input="form.accountingValue = valueNumber($event)"
            @change="autoSaveField( 'accountingValue')"
          />
        </el-form-item>
        <el-form-item
          prop="accountingValueCurrencyID"
          class="price-field__value material-style"
        >
          <select-response
            :model.sync="form.accountingValueCurrencyID"
            @on-change="autoSaveField( 'accountingValueCurrencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-lg-4 col-md-6 col-12 price-field">
        <el-form-item
          :label="L10n('part-price')"
          prop="partPrice"
          class="price-field__field material-style"
          :rules="getValidationRule('number')"
        >
          <el-input
            :value="form.partPrice"
            @input="form.partPrice = valueNumber($event)"
            @change="autoSaveField( 'partPrice')"
          />
        </el-form-item>
        <el-form-item
          prop="priceCurrencyID"
          class="price-field__value material-style"
        >
          <select-response
            :model.sync="form.priceCurrencyID"
            @on-change="autoSaveField( 'priceCurrencyID')"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <!-- MEDIAS -->
    <div class="row">
      <!-- title -->
      <div class="col-12">
        <h3 class="blue-text">{{L10n('medias')}}</h3>
      </div>
      <!-- content -->
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('ppw-path')"
          prop="ppwPath"
          class="material-style"
        >
          <div class="field-open-file">
            <el-input
              type="textarea"
              :rows="3"
              :value="form.ppwPath"
              @input="form.ppwPath = valueTrimLeft($event)"
              @change="autoSaveField( 'ppwPath')"
            />
            <ui-button
              type="button"
              :disabled="!form.ppwPath || disabledForm"
              class="btn btn-size-s btn-font-lighter disabled-white btn-open-file"
              @click.stop.prevent="$emit('open-file', form.ppwPath)"
            >{{L10n('open-file')}}</ui-button>
          </div>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('ppw-attached')"
          prop="ppwAttached"
          class="material-style"
        >
          <div class="field-open-file">
            <el-input
              type="textarea"
              :rows="3"
              :value="form.ppwAttached"
              @input="form.ppwAttached = valueTrimLeft($event)"
              @change="autoSaveField( 'ppwAttached')"
            />
            <ui-button
              :disabled="!form.ppwAttached || disabledForm"
              class="btn btn-size-s btn-font-lighter disabled-white btn-open-file"
              @click.stop.prevent="$emit('open-file', form.ppwAttached)"
            >{{L10n('open-file')}}</ui-button>
          </div>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('photo-attached')"
          prop="photoAttached"
          class="material-style"
        >
          <div class="field-open-file">
            <el-input
              type="textarea"
              :rows="3"
              :value="form.photoAttached"
              @input="form.photoAttached = valueTrimLeft($event)"
              @change="autoSaveField( 'photoAttached')"
            />
            <ui-button
              :disabled="!form.photoAttached || disabledForm"
              class="btn btn-size-s btn-font-lighter disabled-white btn-open-file"
              @click.stop.prevent="$emit('open-file', form.photoAttached)"
            >{{L10n('open-file')}}</ui-button>
          </div>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
// mixins
import Form from '@/components/Form/Form'
import { stringToDate } from '@/utils/shared'
import SelectPartNumber from '@/components/Shared/SelectPartNumber/Index'
import SelectCompany from '@/components/Shared/SelectCompany/Index'

export default {
  name: 'FormStock',
  mixins: [Form],
  components: {
    'select-part-number': SelectPartNumber,
    'select-company': SelectCompany
  },
  props: {
    disabledPart: { type: Boolean, default: false },
    hasCreateNew: { type: Boolean, required: true }
  },
  computed: {
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title')
    },
    dataSourceSalesRemark () {
      return this.API('StockSalesRemarks/GetAllDynamic?select=id,remark')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceLocation () {
      return this.API('StockLocations/GetAllDynamic?select=id,title')
    },
    dataSourceStatus () {
      return this.API('Statuses/GetAllDynamic?select=id,title')
    },
    dataSourceWarehouseLocation () {
      return this.API('WarehouseLocations/GetAllDynamic?select=id,title')
    },
    daysField () {
      return this.$moment(new Date()).diff(this.form.tagDate || new Date(), 'days')
    },
    classDaysField () {
      const days = this.$moment(new Date()).diff(this.form.tagDate || new Date(), 'days')
      return {
        'field-warn': days >= 365 && days <= 730,
        'field-warn-extra': days > 730
      }
    },
    daysMessage () {
      const days = this.$moment(new Date()).diff(this.form.tagDate || new Date(), 'days')
      if (days >= 356 && days <= 730) {
        return this.L10n('tag-date-over-yea')
      } else if (days > 730) {
        return this.L10n('tag-date-must-move')
      } else {
        return ''
      }
    },
    classDaysMessage () {
      const days = this.$moment(new Date()).diff(this.form.tagDate || new Date(), 'days')
      return {
        'field-warn-extra': days > 730
      }
    },
    permissions () {
      return this.$store.getters.get('permissions')
    },
    isHighPermission () {
      return this.$store.getters.isHighPermission
    },
    isAvailableEditPartNumber () {
      return this.permissions.isAllowToEditStocks
    },
    shelfLifeLimitClass () {
      return {
        'field-warn-extra': !!(this.form.shelfLifeLimit && (stringToDate(this.form.shelfLifeLimit) < new Date()))
      }
    },
    isAvailableEditOwner () {
      if (this.disabledForm) {
        return false
      }
      if (!this.hasCreateNew) {
        return true
      } else {
        return this.isHighPermission
      }
    }
  },
  methods: {
    statusDateToday () {
      this.form.statusDate = new Date()
      this.autoSaveField('statusDate')
    }
  }
}
</script>
<style lang="stylus">
  .field-open-file{
    display flex
    align-items flex-end
  }
  .btn.btn-open-file{
    border 1px solid #06aaea
    &[disabled]{
      opacity 1
      border-color #bcbbbe
      background white
      color #06aaea
    }
  }
  button{
    &.btn{
      &.btn-supplier{
        &.is-active{
          background #06aaea
          color #fff
        }
      }
    }
  }

</style>
<style lang="stylus" scoped>
  .field-top-button {
    position: absolute;
    top: -1.2rem;
    right: 0;
  }
</style>
